export default {
    methods: {
        cerrarSesion(firebase) {
            //Presence Channel
            this.limpiarSesion(firebase);
          
            if (this.User == null) {
                if(this.$store.state.is_teacher){
                    localStorage.setItem('lang', "en");
                    this.$router.push({ name: 'teacher/login' });
                    this.$store.commit('mutateIsTeacher', false);
                }else{
                    //localStorage.setItem('lang', "en");
                    this.$store.commit('mutateIsTeacher', false);
                    this.$router.push({ name: 'student/login' });
                }
            }

            //is_representative
            //group_person_id
            //group_id
            //is_group
        },
        limpiarSesion(firebase){
             
            let presence_channel = this.$pusher.subscribe('presence-whatsup-members');
            if(this.User != null){
                presence_channel.trigger("client-pusher:member_removed", {id: this.User.id});
            }
			
            presence_channel.unbind('pusher:subscription_succeeded');
            presence_channel.unbind('pusher:member_added');
            presence_channel.unbind('pusher:member_removed');
            this.$pusher.unsubscribe("presence-whatsup-members");
            
            let group_channel = this.$pusher.subscribe('group_chat');
            group_channel.unbind('typingMessage');
            group_channel.unbind('RefreshChat');
            this.$pusher.unsubscribe("group_chat");
            
            if(firebase.messaging != null && firebase.messaging.isSupported()){
                firebase.messaging().deleteToken().catch(error => console.log(error));
            }

            this.User = null;
            this.$store.commit('mutateUser', null);
		    this.$store.commit('mutateUserId', 0);
            //this.state.user_id = 0;
            this.$store.commit('mutateGroupPersonId', 0);
            this.$store.commit('mutateGroupId', 0);
            this.$store.commit('mutateDatosSidebar', null);
            
            this.$store.commit('mutateIsRepresentative', false);
            this.$store.commit('mutateIsAdmin', false);
            this.$store.commit('mutateUpdateFlagSubject', false);
            this.$store.commit('mutateFlagPostulant', false);
            this.$store.commit('mutateFlagValidateCalifications', false);
            this.$store.commit('mutateUpdateViewStudent', false);

            this.$store.commit('mutateFlagViewModalTimeZone', true);
            this.$store.commit('mutateAuthToken', null);
        },
        validarSesion() {
            if (this.UserId == 0 || this.User == null) {
                //this.$router.push({ name: 'login' });
            }            
        },
        logoRedireccion(flagPurchaseHistory) {
           
            if(!flagPurchaseHistory){ //SI NUNCA HA COMPRADO UN PLAN...
                
                this.$router.push({ path: `/compra/0` }).catch(err => {});
               
            }else{
                this.$router.push({ name: `dashboard` }).catch(err => {}); 
            }
 
        }
    }
};
